












































import { computed, defineComponent, getCurrentInstance, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageDeleteAccount",
  components: { BaseConfirm, BasePage, PageTitle, BaseButton },
  setup() {
    const vm = getCurrentInstance();
    const showConfirm = ref(false);
    const showGoodBye = ref(false);
    const deleting = ref(false);
    const { authUserStrict } = useAuthUser();
    const isCreator = computed(() => authUserStrict.value.role === "creator");
    const onDeleteClick = async () => {
      try {
        deleting.value = true;
        await providers.UserProvider.disable({ data: { id: authUserStrict.value.id, disable: true } });
        setTimeout(() => {
          vm?.$router.push({ name: "logout" });
        }, 5000);
      } finally {
        deleting.value = false;
        showConfirm.value = false;
        showGoodBye.value = true;
      }
    };
    return {
      deleting,
      showConfirm,
      showGoodBye,
      isCreator,
      onDeleteClick,
    };
  },
});
